if (Promise.withResolvers === undefined) {
  Promise.withResolvers = function () {
    let resolve, reject;

    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}

if (Object.hasOwn === undefined) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

if (Array.prototype.toSorted === undefined) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value: function toSorted(compareFn) {
      return this.slice().sort(compareFn);
    },
    writable: true,
    configurable: true,
    enumerable: false, // need for hide from for in loops and etc.
  });
}
